var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833984 3.33331V8.33331H5.83398",
    stroke: "#5458F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.166 16.6667V11.6667H14.166",
    stroke: "#5458F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0756 7.49998C16.653 6.30564 15.9347 5.23782 14.9878 4.39616C14.0408 3.55451 12.8961 2.96645 11.6604 2.68686C10.4247 2.40727 9.13835 2.44527 7.92132 2.79729C6.70429 3.14932 5.59627 3.80391 4.70065 4.69998L0.833984 8.33331M19.1673 11.6666L15.3007 15.3C14.405 16.1961 13.297 16.8506 12.08 17.2027C10.8629 17.5547 9.57657 17.5927 8.34089 17.3131C7.10521 17.0335 5.96048 16.4455 5.01354 15.6038C4.06659 14.7621 3.34829 13.6943 2.92565 12.5",
    stroke: "#5458F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.8c7a8290.svg";
export { ForwardRef as ReactComponent };